// src/components/report/InvestmentGrowth.js
import React from 'react';

const MetricCard = ({ title, value, subtitle, trend }) => (
  <div className="bg-white rounded-xl p-6 shadow-lg">
    <h4 className="text-sm text-gray-500 mb-2">{title}</h4>
    <div className="flex items-baseline gap-2 mb-1">
      <div className="text-2xl font-bold text-[#234363] ltr">
        {value}
      </div>
      {trend && (
        <div className={`text-sm ltr ${trend > 0 ? 'text-green-600' : 'text-red-600'}`}>
          {trend > 0 ? '+' : ''}{trend}%
        </div>
      )}
    </div>
    {subtitle && (
      <div className="text-sm text-gray-600">{subtitle}</div>
    )}
  </div>
);

const InvestmentGrowth = ({ yearComparison, growthAnalysis }) => {
  if (!yearComparison || !growthAnalysis) return null;

  const year2023 = yearComparison['2023'] || { transaction_count: 0, total_invested: 0 };
  const year2024 = yearComparison['2024'] || { transaction_count: 0, total_invested: 0 };

  return (
    <div className="space-y-6 mb-6">
      <h3 className="text-lg font-bold text-[#234363]">تحليل النمو</h3>
      
      <div className="grid grid-cols-1 md:grid-cols-3 gap-4">
        <MetricCard
          title="نمو المعاملات"
          value={year2024.transaction_count}
          subtitle="معاملة في 2024"
          trend={growthAnalysis?.transaction_growth?.percentage.toFixed(1)}
        />
        
        <MetricCard
          title="نمو الاستثمار"
          value={`EGP ${parseInt(year2024.total_invested || 0).toLocaleString()}`}
          subtitle="إجمالي استثمارات 2024"
          trend={growthAnalysis?.investment_growth?.percentage.toFixed(1)}
        />
        
        <MetricCard
          title="متوسط التحويش الشهري"
          value={`EGP ${(parseInt(year2024.total_invested || 0) / 12).toLocaleString()}`}
          subtitle="في 2024"
        />
      </div>

      <div className="bg-white rounded-xl p-6 shadow-lg">
        <h4 className="font-bold text-sm mb-4">مقارنة سنوية</h4>
        <div className="grid grid-cols-2 gap-8">
          <div>
            <h5 className="text-sm text-gray-500 mb-2">2023</h5>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">عدد المعاملات</span>
                <span className="ltr font-medium">{year2023.transaction_count}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">إجمالي المدخرات</span>
                <span className="ltr font-medium">
                  EGP {parseInt(year2023.total_invested || 0).toLocaleString()}
                </span>
              </div>
            </div>
          </div>
          <div>
            <h5 className="text-sm text-gray-500 mb-2">2024</h5>
            <div className="space-y-2">
              <div className="flex justify-between">
                <span className="text-gray-600">عدد المعاملات</span>
                <span className="ltr font-medium">{year2024.transaction_count}</span>
              </div>
              <div className="flex justify-between">
                <span className="text-gray-600">إجمالي المدخرات</span>
                <span className="ltr font-medium">
                  EGP {parseInt(year2024.total_invested || 0).toLocaleString()}
                </span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default InvestmentGrowth;